// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@400;500);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#toolbar {
  position: absolute;
  top: 0px;
  left: 0px;
  backdrop-filter: blur(4px);
  height: auto;
  border-radius: 6px;
  padding: 2px;
  transition: 0.2s ease-in-out;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  width: 100%;
}

.MenubarRoot {
  display: flex;
  background-color: rgba(50, 50, 50, 0.8);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border-radius: 6px;
  gap: 2px;
  padding: 6px;
}

.MenubarTrigger {
  all: unset;
  padding: 6px 12px;
  outline: none;
  user-select: none;
  font-weight: 500;
  line-height: 1;
  border-radius: 6px;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2px;
  cursor: pointer;
}
.MenubarTrigger[data-highlighted] {
  background-color: #262626;
}
.MenubarTrigger[data-state=open] {
  background-color: #262626;
}

.MenubarContent {
  min-width: 220px;
  background-color: rgba(30, 30, 30, 0.8);
  border-radius: 8px;
  padding: 6px;
  box-shadow: 0px 10px 38px -10px rgba(22, 23, 24, 0.35), 0px 10px 20px -15px rgba(22, 23, 24, 0.2);
  animation-duration: 0ms;
  will-change: transform, opacity;
  z-index: 15;
  backdrop-filter: blur(8.5px);
  -webkit-backdrop-filter: blur(8.5px);
  max-height: 80vh;
  overflow-y: auto;
}

.MenubarItem {
  all: unset;
  font-size: 16px;
  line-height: 1.2;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 24px;
  padding: 4px 12px;
  position: relative;
  user-select: none;
  cursor: pointer;
  margin: 1px 0;
}
.MenubarItem[data-highlighted] {
  background-color: #161616;
  outline: none;
}
.MenubarItem[data-disabled] {
  color: #555;
  pointer-events: none;
}

.MenubarCheckboxItem {
  all: unset;
  font-size: 16px;
  line-height: 1.2;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 24px;
  padding: 4px 12px;
  padding-left: 36px;
  position: relative;
  user-select: none;
  cursor: pointer;
  margin: 1px 0;
}
.MenubarCheckboxItem[data-highlighted] {
  background-color: #161616;
  outline: none;
}
.MenubarCheckboxItem[data-disabled] {
  color: #555;
  pointer-events: none;
}

.MenubarItemIndicator {
  position: absolute;
  left: 12px;
  width: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.MenubarSeparator {
  height: 1px;
  background-color: #aaa;
  margin: 6px 4px;
}

.RightSlot {
  margin-left: auto;
  padding-left: 20px;
  color: #c3c3c3;
}

[data-highlighted] > .RightSlot {
  color: #fff;
}

[data-disabled] > .RightSlot {
  color: #dbdbdb;
}

.pro-badge {
  background-color: #774dee;
  padding: 0px 8px;
  border-radius: 8px;
  margin-left: 8px;
  font-size: 0.775rem;
  font-weight: normal;
  display: inline-block;
}`, "",{"version":3,"sources":["webpack://./src/editor/style/AppMenu.scss","webpack://./src/editor/style/variables.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,0BAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,4BAAA;EACA,wCAAA;EACA,WAAA;AAAF;;AAIA;EACE,aAAA;EACA,uCAAA;EACA,0BAAA;EACA,kCAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;AADF;;AAIA;EACE,UAAA;EACA,iBAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,eAAA;AADF;AAEE;EACE,yBCIQ;ADJZ;AAGE;EACE,yBAAA;AADJ;;AAKA;EACE,gBAAA;EACA,uCCWc;EDVd,kBAAA;EACA,YAAA;EACA,iGACE;EAEF,uBAAA;EACA,+BAAA;EACA,WAAA;EACA,4BAAA;EACA,oCAAA;EACA,gBAAA;EACA,gBAAA;AAJF;;AAOA;EACE,UAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;AAJF;AAKE;EACE,yBCvCQ;EDwCR,aAAA;AAHJ;AAME;EACE,WCzDY;ED0DZ,oBAAA;AAJJ;;AAQA;EACE,UAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;AALF;AAME;EACE,yBCjEQ;EDkER,aAAA;AAJJ;AAOE;EACE,WCnFY;EDoFZ,oBAAA;AALJ;;AASA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AANF;;AASA;EACE,WAAA;EACA,sBC3GU;ED4GV,eAAA;AANF;;AASA;EACE,iBAAA;EACA,kBAAA;EACA,cCjHc;AD2GhB;;AASA;EACE,WCzHM;ADmHR;;AASA;EACE,cCtHc;ADgHhB;;AASA;EACE,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;AANF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
